import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

const ContactFormDW = ({ haveBusiness, onClose }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Trigger opening animation
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => onClose(), 300);
  };

  const handleSubmit = (values, { resetForm }) => {
    fetch(
      "https://nethunt.com/service/automation/hooks/66fbc7737d6ffe000853837b",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      },
    );
    resetForm();
    navigate("/thank-you");
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Введіть своє ім'я"),
    phone: Yup.string()
      .matches(
        /^(380\d{9}|34\d{9}|1\d{10})$/,
        "Невірний формат номера телефону",
      )
      .required("Введіть номер телефону"),
    text: Yup.string(),
  });

  const form = (
    <Formik
      initialValues={{ name: "", phone: " ", text: "" }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue, isSubmitting }) => (
        <Form>
          <div className="form-block__text" style={{ fontSize: "2rem" }}>
            Залиште контакти
          </div>
          <div className="form-block__text" style={{ marginBottom: "1rem" }}>
            І ми зв'яжемося з вами найближчим часом 💛
          </div>
          <div className="form-block__field">
            <label className="form-block__label">Ім'я</label>
            <Field
              type="text"
              name="name"
              placeholder="Введіть своє ім'я"
              className="form-block__input"
              autoComplete="off"
            />
            <ErrorMessage
              name="name"
              component="div"
              className="error-message"
            />
          </div>

          <div className="form-block__field">
            <label className="form-block__label">Номер телефону</label>
            <PhoneInput
              country={"ua"}
              onlyCountries={["ua"]}
              placeholder="Введіть номер телефону"
              value={values.phone}
              showDropdown={false}
              onChange={(phone) => setFieldValue("phone", phone)}
              inputClass="form-block__input tel-input"
              countryCodeEditable={false}
            />
            <ErrorMessage
              name="phone"
              component="div"
              className="error-message"
            />
          </div>

          <button
            type="submit"
            className="form-block__btn button"
            disabled={isSubmitting}
            style={{ width: "100%", marginTop: "1rem" }}
          >
            ВІДПРАВИТИ
          </button>
        </Form>
      )}
    </Formik>
  );

  const iDontHaveBusiness = (
    <div>
      <div
        className="form-block__text"
        style={{ fontSize: "2rem", textAlign: "center" }}
      >
        Нічого страшного!
      </div>
      <div className="form-block__text" style={{ marginTop: "1.5rem" }}>
        Збережіть{" "}
        <a href={"https://scout.com.ua"} style={{ color: "#fd9904" }}>
          наш сайт
        </a>{" "}
        на майбутнє, коли будете готові. Ми будемо раді бачити вас знову 💛
      </div>
    </div>
  );

  return (
    <div
      className={`popup-overlay ${isVisible ? "visible" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`popup-container ${isVisible ? "visible" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {haveBusiness !== 2 && (
          <button className="popup-close" onClick={handleClose}>
            ×
          </button>
        )}

        {haveBusiness === 1 ? form : iDontHaveBusiness}
      </div>
    </div>
  );
};

export default ContactFormDW;
